import { render, staticRenderFns } from "./businessRanking.vue?vue&type=template&id=5b09d420&scoped=true"
import script from "./businessRanking.vue?vue&type=script&lang=js"
export * from "./businessRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09d420",
  null
  
)

export default component.exports